import React, { useState } from 'react';

function SqlSidebar({
  dbObjects,
  selectedType,
  setSelectedType,
  setSelectedObject,
}) {
  const [openTypes, setOpenTypes] = useState({});
  const [searchTerm, setSearchTerm] = useState('');

  // Group objects by type
  const grouped = dbObjects?.reduce((acc, obj) => {
    if (!acc[obj.type]) acc[obj.type] = [];
    acc[obj.type].push(obj);
    return acc;
  }, {});

  const toggleType = (type) => {
    setOpenTypes((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  return (
    <div
      className="sidebar p-3 border-end bg-light"
      style={{ width: '280px', height: '100vh', overflowY: 'auto' }}
    >
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Search objects..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
        />
      </div>

      {Object.entries(grouped).map(([type, items]) => {
        const filteredItems = items.filter((obj) =>
          obj.name.toLowerCase().includes(searchTerm)
        );
        const isOpen = searchTerm
          ? filteredItems.length > 0 // Open if there are matching items during search
          : openTypes[type]; // Use manual toggle if no search

        // Skip section if no items match search
        if (searchTerm && filteredItems.length === 0) return null;

        return (
          <div key={type} className="mb-3">
            <h5
              onClick={() => toggleType(type)}
              style={{
                cursor: 'pointer',
                background: '#e9ecef',
                padding: '6px 10px',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                fontSize: '16px',
              }}
            >
              <span
                style={{
                  marginRight: '6px',
                  width: '20px',
                  display: 'inline-block',
                }}
              >
                {isOpen ? '−' : '+'}
              </span>
              {type.toUpperCase()}
            </h5>

            <ul className="list-unstyled ps-4">
              {isOpen &&
                filteredItems.map((obj, i) => (
                  <li
                    key={i}
                    onClick={() => {
                      setSelectedObject(obj);
                      setSelectedType(type);
                    }}
                    style={{
                      cursor: 'pointer',
                      padding: '4px 0',
                      color: '#0d6efd',
                    }}
                  >
                    {obj.name}
                  </li>
                ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
}

export default SqlSidebar;
